import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

// initial state
const state = {
  productId: 0,
  search: {
    page: 1,
    limit: 10,
    sort: 'id',
    order: 'asc'
  },
  result: {
    lists: [],
    count: 0,
    page: 1,
    pricingModel: 1
  },
  attributes: []
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/variants/index.js